import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const StyledMapWrapper = styled.div`
  .ant-popover-inner {
    border-radius: 5px !important;
  }

  .ant-popover-inner-content {
    padding: 0px !important;
  }

  width: 100%;
`;

export interface IMapMarkerProps {
  lat?: number;
  lng?: number;
  content?: React.ReactNode;
  onClick?: () => void;
  isOpened?: boolean;
  isFocused?: boolean;
}

const MapMarker = (props: IMapMarkerProps) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (props.isOpened && !visible) setVisible(props.isOpened || false);
  }, [props.isOpened]);

  return (
    <StyledMapWrapper
      className="relative"
      style={{ zIndex: props.isFocused ? 9999999 : 10 }}
      key={props.lat + props.lng}
      onClick={props.onClick}
    >
      <div className="flex justify-center items-center">
        {visible && (
          <>
            <div className="absolute shadow-sm bottom-[30px] bg-white px-7 text-black rounded-md font-bold py-2">
              {props.content}
            </div>
            <div
              style={{ transform: 'rotate(45deg)' }}
              className="bg-white shadow-sm absolute -z-10 bottom-[25px] aspect-square w-4 h-4"
            />
          </>
        )}
        <div className="animate-bounce cursor-pointer rounded-full aspect-square shadow-md w-[14px] h-[14px] bg-white p-1 flex items-center justify-center">
          <div className="bg-main rounded-full aspect-square w-2 h-2 " />
        </div>
      </div>
    </StyledMapWrapper>
  );
};

export default MapMarker;
